import { inject, Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root',
})
export class SnackbarService {
  private snackbar = inject(MatSnackBar);
  private showingMessage = false;

  error(message: string) {
    this.showingMessage = true;
    this.snackbar
      .open(message, 'Close', {
        duration: 3000,
        panelClass: ['snack-error'],
        verticalPosition: 'top',
      })
      .afterOpened()
      .subscribe(() => {
        this.showingMessage = false;
      });
  }

  success(message: string) {
    this.showingMessage = true;
    this.snackbar
      .open(message, 'Close', {
        duration: 3000,
        panelClass: ['snack-success'],
        verticalPosition: 'top',
      })
      .afterOpened()
      .subscribe(() => {
        this.showingMessage = false;
      });
  }

  isShowingMessage(): boolean {
    return this.showingMessage;
  }
}
